'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactFontawesome = require('@fortawesome/react-fontawesome');

var _freeRegularSvgIcons = require('@fortawesome/free-regular-svg-icons');

require('./hoo.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var hooRegex = /(\d+:\d\d [A-Z]{2} . \d+:\d\d [A-Z]{2})/g;
var hourRegex = /(\d+:\d\d [A-Z]{2})/g;

var week = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

var openDesc = _react2.default.createElement(
  'span',
  null,
  'We are currently ',
  _react2.default.createElement(
    'span',
    { className: 'hoo-open-emphasis' },
    'open'
  ),
  ' until '
);
// const closedDesc = <span>We are currently <span className="hoo-closed-emphasis">closed</span> but will open at </span>;
var closedDesc = _react2.default.createElement(
  'span',
  null,
  'We are currently ',
  _react2.default.createElement(
    'span',
    { className: 'hoo-closed-emphasis' },
    'closed'
  ),
  '.'
);
var permanentlyClosedDesc = _react2.default.createElement(
  'span',
  null,
  'We are ',
  _react2.default.createElement(
    'span',
    { className: 'hoo-closed-emphasis' },
    'closed'
  ),
  ' but will open sometime soon!'
);

var Hoo = function (_React$Component) {
  _inherits(Hoo, _React$Component);

  function Hoo() {
    _classCallCheck(this, Hoo);

    var _this = _possibleConstructorReturn(this, (Hoo.__proto__ || Object.getPrototypeOf(Hoo)).call(this));

    _this.state = { description: null, today: null, isOpen: null };
    _this.setDescription = _this.setDescription.bind(_this);
    _this.parseDateTime = _this.parseDateTime.bind(_this);
    return _this;
  }

  _createClass(Hoo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      this.setDescription();
      this.checkTime = setInterval(function () {
        return _this2.setDescription();
      }, 60000);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      clearInterval(this.checkTime);
    }
  }, {
    key: 'setDescription',
    value: function setDescription() {
      var description = this.parseDateTime();
      var today = (0, _moment2.default)().isoWeekday() - 1;
      this.setState({ description: description, today: today });
    }
  }, {
    key: 'parseDateTime',
    value: function parseDateTime() {
      var hours = this.props.hours;

      var now = (0, _moment2.default)();
      var today = now.isoWeekday() - 1;
      var todayHours = hours[today].match(hooRegex);

      var day = today;
      var closedEntireDay = hours[today].indexOf('Closed') !== -1;
      var closedForDay = !closedEntireDay && (0, _moment2.default)(todayHours[todayHours.length - 1].match(hourRegex)[1], 'hh:mm A').isBefore(now);
      if (closedEntireDay || closedForDay) {
        this.setState({ isOpen: false });
        return _react2.default.createElement(
          'span',
          null,
          closedDesc
        );
        // // find next day open if closed for the day or entire day
        // while (hours[day % 7].indexOf('Closed') !== -1) {
        //   day++;
        //   if (day > today + 7) {
        //     return permanentlyClosedDesc;
        //   }
        // }
        //
        // const nextOpeningTime = hours[day].match(hooRegex)[0].match(hourRegex)[0];
        // const openingDay = (day - today) === 1 ? ' tomorrow!' : ` on ${week[day]}!`;
        // return <span>{closedDesc}<span>{nextOpeningTime + openingDay}</span></span>;
      }
      for (var x = 0; x < todayHours.length; x++) {
        var opHour = todayHours[x].match(hourRegex);
        if (now.isBefore((0, _moment2.default)(opHour[0], 'hh:mm A'))) {
          this.setState({ isOpen: false });
          return _react2.default.createElement(
            'span',
            null,
            closedDesc
          );
          // return <span>{closedDesc}<span>{`${opHour[0]} today!`}</span></span>;
        } else if (now.isBefore((0, _moment2.default)(opHour[1], 'hh:mm A'))) {
          this.setState({ isOpen: true });
          return _react2.default.createElement(
            'span',
            null,
            openDesc,
            _react2.default.createElement(
              'span',
              null,
              opHour[1] + '!'
            )
          );
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          description = _state.description,
          today = _state.today,
          isOpen = _state.isOpen;
      var hours = this.props.hours;

      return _react2.default.createElement(
        'div',
        { id: 'hoo-container' },
        _react2.default.createElement(
          'div',
          { id: 'hoo-header' },
          _react2.default.createElement(
            'div',
            { id: 'call-icon-container' },
            _react2.default.createElement(_reactFontawesome.FontAwesomeIcon, { icon: _freeRegularSvgIcons.faClock, size: '2x' })
          ),
          _react2.default.createElement(
            'div',
            null,
            description
          )
        ),
        _react2.default.createElement(
          'div',
          { id: 'hoo-hours' },
          hours.map(function (day, idx) {
            return idx === today && isOpen ? _react2.default.createElement(
              'div',
              { key: idx, className: 'hoo-emphasis emphasis-text' },
              day
            ) : _react2.default.createElement(
              'div',
              { key: idx },
              day
            );
          })
        )
      );
    }
  }]);

  return Hoo;
}(_react2.default.Component);

exports.default = Hoo;


Hoo.propTypes = {
  hours: _propTypes2.default.array.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./~/@fishrmn/fishrmn-components/build/components/molecules/Hoo/Hoo.js
// module id = 487
// module chunks = 168707334958949